import { createSlice } from "@reduxjs/toolkit";
import { getUsersService } from "../services/users_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  usersList: [],
  metaUsers:null
};

const slice = createSlice({
  name: "clients",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getUsersService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.usersList = action.payload?.data?.data;
        state.metaUsers = action.payload.data.meta.meta;
      })
      .addCase(getUsersService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getUsersService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
